export type TDateFilterErrorCode = 'START_IS_GREATER' | 'RANGE_OUT_OF_WEEK_LENGTH' | 'START_OUT_OF_MONTH_RANGE';
export const DateFilterErrorCodeToMsgMap: Record<TDateFilterErrorCode, string> = {
  START_IS_GREATER: 'Start date is greater than end date',
  RANGE_OUT_OF_WEEK_LENGTH: 'Maximum supported range is 7Days from start date',
  START_OUT_OF_MONTH_RANGE: 'Selection range should be within 30 days',
};
